import React, { Component } from 'react';
import { debounce, isEqual } from 'lodash';
import Fuse from 'fuse.js';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getOnboardingState, getAuthState } from '../../store/selectors';
import { updateUserProgress } from '../../store/actions';
import Spyglass from '../utility/Spyglass';

class FuzzySearchBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searcher: {},
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.listToSearch &&
      JSON.stringify(prevProps.listToSearch) !==
        JSON.stringify(this.props.listToSearch)
    ) {
      const options = {
        includeScore: true,
        keys: ['titleEn', ...(this.props.searchKeys || [])],
        threshold: 0.5,
      };
      const searcher = new Fuse(this.props.listToSearch, options);
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ searcher });
    }
    if (
      !isEqual(this.props.careerList, prevProps.careerList) &&
      this.props.careerList.length === 20
    ) {
      const options = {
        includeScore: true,
        keys: ['titleEn'],
        threshold: 0.5,
      };

      const searcher = new Fuse(this.props.careerList, options);

      // this is okay when using prevProps
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        searcher,
      });
    }
  }

  componentDidMount() {
    const options = {
      includeScore: true,
      keys: ['titleEn', ...(this.props.searchKeys || [])],
      threshold: 0.5,
    };

    const searcher = new Fuse(this.props.listToSearch, options);

    this.setState({
      searcher,
    });
  }

  holdYourHorses = debounce((inputVal) => {
    if (inputVal === '') {
      this.props.sendFilteredListToParent(this.props.listToSearch);
      this.props.setSearchListLoadingOnParent(false);

      return;
    }
    if (
      this.props.inputText.includes('Career') &&
      !this.props.onboarding.userData.userProgress?.searched_career
    ) {
      this.props.updateUserProgress(this.props.auth.jwtToken, {
        searched_career: true,
      });
    }
    const { searcher } = this.state;
    const result = searcher.search(`=${inputVal}`).map((searchResult) => {
      return searchResult.item;
    });

    this.props.sendFilteredListToParent(result);
    this.props.setSearchListLoadingOnParent(false);
  }, 250);

  async handleInputOnChange(inputVal) {
    await this.props.setSearchListLoadingOnParent(true);
    this.holdYourHorses(inputVal);
  }

  render() {
    return (
      <>
        <input
          aria-label="career searchbar"
          placeholder={`${this.props.inputText}`}
          data-cy="career-searchbar"
          className={
            this.props.mobile
              ? [
                  'career-searchbar mobile',
                  this.props.overRideStylesSearchBar,
                ].join(' ')
              : ['career-searchbar', this.props.overRideStylesSearchBar].join(
                  ' '
                )
          }
          onChange={(event) => {
            this.handleInputOnChange(event.target.value);
          }}
        />
        <Spyglass
          color={this.props.tenant.primary}
          overRideStylesMag={this.props.overRideStylesMag}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const onboarding = getOnboardingState(state);
  const auth = getAuthState(state);
  return { onboarding, auth };
};

export default withRouter(
  connect(mapStateToProps, { updateUserProgress })(FuzzySearchBar)
);
